module.exports = __webpack_public_path__ + "img/Red-seguridad-p-500.9ca863d5.png";